import { createMapAction } from "chalet-shared";

import { MessageDropdownInfo } from "../reducers/messageDropdown";

export const actionCreators = {
    setMessageDropdown: createMapAction(
        "SET_MESSAGE_DROPDOWN",
        (x: MessageDropdownInfo | null) => x
    ),
};
